import { useQuery } from "react-query";
import { customerUpdate } from "@/repositories/customerUpdates";

interface UseAvailableUpdateTimeParams {
  shopId: string;
  userId: string;
  desiredUpdateTime: Date;
  enabled?: boolean;
}

export const useAvailableUpdateTime = ({
  shopId,
  userId,
  desiredUpdateTime,
  enabled = true,
}: UseAvailableUpdateTimeParams) => {
  return useQuery({
    queryKey: [
      "availableUpdateTime",
      shopId,
      userId,
      desiredUpdateTime.toISOString(),
    ],
    queryFn: async (): Promise<Date | null> => {
      const result = await customerUpdate.getAvailableUpdateTime(
        shopId,
        userId,
        desiredUpdateTime
      );
      console.log("Available update time result:", result);
      // The Firebase function returns a Date or null

      return result.data;
    },
    enabled: enabled && !!shopId && !!userId && !!desiredUpdateTime,
    staleTime: 30 * 1000, // Cache for 30 seconds
    cacheTime: 2 * 60 * 1000, // Keep in cache for 2 minutes
  });
};
